<template>
  <div :class="'navbar-container'+(scrollTop>10?' zoom':'')">
    <el-row class="main-box navbar">
      <template v-for="(item, index) in menus">
        <el-col
          v-if="item.name!='Join Us'"
          @mouseover.native="mouseover(index)"
          :key="index"
          :span="item.name=='logo'&&index==0?6:item.name=='logo'?5:item.name=='lang'?1:item.name=='Research Centers'||item.name=='Industry Practice'?4:3"
          :class="'text-center navbar-item'+(item.mouseover?' hover':'')"
        >
          <router-link class="navbar-item-menu" active-class="active" v-if="item.name!='logo'&&index!==7" :to="item.link">{{item.name}}</router-link>
          <router-link class="lang-box" :to="langHref" v-if="item.name=='lang'">{{lang}}</router-link>
          <img :src="require('../assets/img/logo.svg')" v-if="item.name=='logo'" class="logo" />
          
          <div v-if="item.child&&item.child.length>0" class="second-menu">
            <el-row class="main-box">
              <el-col v-for="(child, childIndex) in item.child" :key="childIndex" :span="Math.floor(24/item.child.length)">
                <dl>
                  <dt>
                    <router-link class="menulink" :to="child.link"> {{child.name}}</router-link>
                  </dt>
                  <dd v-for="(child2, childIndex2) in child.child" :key="childIndex2" >
                    <router-link class="menulink" :to="child2.link"> {{child2.name}}</router-link>
                  </dd>
                </dl>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </template>
    </el-row>
  </div>
</template>

<script>
import mixin from "../mixin.js";
import { navbar } from "../data.js";
export default {
  name: "navbar",
  mixins:[mixin],
  data(){
    return {
      scrollTop: 0,
      menus: navbar({
        lang:this.$route.params.lang || 'zh-CN'
      })
    };
  },
  computed:{
    lang(){
      return this.$route.params.lang!='en'?'EN':'中文';
    },
    langHref(){
      const lang = this.$route.params.lang || 'zh-CN';
      if(this.$route.fullPath == '/'){
        return '/en/home';
      }else if (lang=="en") {
        return this.$route.fullPath.replace('en', 'zh-CN');
      } else {
        return this.$route.fullPath.replace('zh-CN', 'en');
      }
    },
    scale() {
      let num = 1-(this.scrollTop/120);
      if (num<=0.6){
        num = 0.6;
      }
      return num;
    }
  },
	watch:{
		"$route":function(route){
			this.menus = navbar({
        lang:route.params.lang || 'zh-CN'
      });
		}
	},
  methods:{
    mouseover(index) {
      this.menus = this.menus.map((v, i)=>{
        if (i==index) {
          v.mouseover = true;
        } else {
          v.mouseover = false;
        }
        return v;
      });
    },
    scrollHandler() {
      const scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
      this.scrollTop = scrollTop;
    }
  }
};
</script>

<style lang="less">
@duration: .2s;
.navbar-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
}
.hover {
  &:hover .navbar-item-menu:after {
    content: " ";
    display: block;
    position: absolute;
    bottom: 0;
    height: 3px;
    width: 100%;
    background-color: #d22c1d;
  }
}
.navbar {
  position: static !important;
  &-item {
    .second-menu {
      background-color: rgba(255,255,255,.9);
      position: absolute;
      width: 100%;
      left:0;
      display: none;
      dt,dd{
        margin: 0;
        padding: 0 0 0 20px;
        text-align: left;
      }
      dt {
        color: #333;
        font-weight: 700;
        font-size: 22px;
        margin: 20px 0;
      }
      dd {
        color: #333;
        font-weight: 400;
        font-size: 14px;
        padding-bottom: 20px;
      }
    }
    &:hover .second-menu {
      display: block;
    }
  }
  .navbar-item-menu {
    display: inline-block;
    text-decoration: none;
    line-height: 130px;
    color: #333;
    font-weight: 400;
    font-size: 18px;
    position: relative;
    transition: .6s;
    &:hover{
      color: #d22c1d;
    }
    &.active {
      color: #d22c1d;
    }
  }
  .lang-box {
    position: absolute;
    width: 30px;
    height: 30px;
    line-height: 30px;
    display: inline-block;
    text-decoration: none;
    color: #fff;
    padding: 2px 10px;
    font-size: 12px;
    background-color: #d22c1d;
    top: 50%;
    margin-top: -15px;
  }
  .logo {
    display: inline-block;
    margin-top: 20px;
    height: 70px;
    overflow: hidden;
    transition: @duration;
  }
}
.zoom {
  background-color: #fff;
  .logo {
    margin-top: 10px;
    height: 50px;
  }
  .navbar-item-menu {
    line-height: 70px;
  }
}
</style>
